import { IModalWindow } from '@hooks/useModalWindow';
import { IVendedor } from '@model/Vendedor';
import { IVendedorComissao, VendedorComissaoTipoEnum } from '@model/VendedorComissao';
import React from 'react';
import { ComissaoRegistrarModal } from './ComissaoRegistrarModal';

export type ComissaoDebitoModalProps = {
    modal: IModalWindow
    onComissaoRegistrada: (vendedorComissao: IVendedorComissao) => void
    vendedor: IVendedor
}

export function ComissaoDebitoModal ({ modal, vendedor, onComissaoRegistrada }: ComissaoDebitoModalProps) {
    return (
        <ComissaoRegistrarModal 
            modal={modal}
            vendedorComissaoTipo={VendedorComissaoTipoEnum.Debito}
            onComissaoRegistrada={onComissaoRegistrada}
            vendedor={vendedor}
        />
    )
}